<template>
    <v-col>
        <v-col style="padding-bottom:10px">
            <v-row>
                <v-flex>
                    <v-btn elevation="0" style="padding-right:10px;">
                        <v-icon
                                @click="back()"
                        >mdi-arrow-left</v-icon>
                    </v-btn>
                    <v-text justify-center class="ma-5 font-weight-bold justify-center" style="font-size:20px; padding-left:10px;">  Informatie bekijken</v-text></v-flex>

            </v-row>
        </v-col>
        <v-divider></v-divider>

        <v-col style="padding-top:2px;">
            <v-row>
                <v-card
                        width="100%"
                        outlined
                        class="rounded-card"
                        style="border-radius:15px;"

                >
                    <v-row>
                        <v-col cols="auto">
                            <v-img :src="images.info"
                                   style="margin-left:9px"
                                   height="60px"
                                   width="60px"
                            >
                            </v-img>

                        </v-col>
                        <v-col cols="auto">
                            <v-card-title class="pa-0 subtitle-1 font-weight-bold">
                                {{alarm.name}}
                            </v-card-title>
                            <v-card-description class="text-right description justify-start" style="font-size:13px;">{{convertTimestamp(alarm.timestamp)}}</v-card-description>
                        </v-col>

                    </v-row>
                </v-card>


            </v-row>
        </v-col>
        <v-col class="pa-1">
            <v-expansion-panels class="some" v-model="panel">
                <v-expansion-panel
                        v-for="(entry, i) in alarm.workflow"
                        :key="i"
                        elevation="0"
                        class="elevation-0"
                        style="border-radius:15px; margin:3px; box-shadow:none; -webkit-box-shadow: none; -moz-box-shadow: none;"
                        flat
                        accordion
                >
                    <v-expansion-panel-header elevation="0" class="elevation-0">
                        <v-flex>
                            <v-img v-if="entry.completed" src="../assets/checkbox_checked.png" max-width="16px"></v-img>
                            <v-img v-else src="../assets/checkbox_unchecked.png" max-width="16px"></v-img>
                            <v-text class="font-weight-medium ml-10" >{{entry.name}}</v-text>
                            <v-text v-if="entry.completed" class="justify-start" style="font-size: 12px;"> @{{convertTimestamp(entry.timestamp)}}</v-text>
                            <div v-if="entry.notes" class="ml-10">
                                <v-card outlined class="elevation-0">{{entry.notes}}</v-card>
                            </div>
                        </v-flex>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <pre></pre>
                        <v-container v-if="entry.name ==='Informatie'">
                            <v-card
                                    outlined
                                    class="mb-4"
                            >
                            <TimeComponent :filter="alarm.log_filter_id"></TimeComponent>
                            </v-card>
                            <v-card
                                    outlined
                                    class="mb-4"
                            >
                                <v-card-text>{{alarm.memo}}</v-card-text>

                            </v-card>
                        </v-container>
                        <v-container v-else-if="entry.name ==='Rapportage'">
                            Conclusie <v-icon @click="addSuggestion(entry.name)">mdi-plus-circle</v-icon>
                            <pre></pre>
                            <v-textarea
                                    v-model="entry.notes"
                                    outlined
                                    multiline
                                    class="mb-0"
                            />
                        </v-container>

                        <v-container v-else-if="entry.name ==='Archiveren'">
                            <v-text class="font-weight-bold" v-if="getPreview().length > 0">Overzicht rapport</v-text>
                            <br/>
                            <v-text class="font-weight-regular"><pre>{{getPreview()}}</pre></v-text>

                        </v-container>




                        <div class="mt-0 justify-end">
                            <v-btn
                                    dark
                                    color="blue darken-3"
                                    @click="openPopup(entry.name)"
                                    small
                            >
                                <i class="material-icons">check_box</i>
                                {{entry.buttonText}}
                            </v-btn>

                            <v-snackbar
                                    v-model="snackbar"
                                    timeout="3000"
                                    top
                            >
                                {{ text }}
                                <v-btn
                                        color="blue darken"
                                        text
                                        @click="snackbar = false"
                                >
                                    Sluiten
                                </v-btn>
                            </v-snackbar>
                        </div>
                        <div class="text-center">
                            <v-dialog
                                    v-model="dialog"
                                    width="500"
                            >

                                <v-card>
                                    <v-card-title
                                            class="headline grey lighten-2"
                                            primary-title
                                    >
                                        Waarschuwing
                                    </v-card-title>

                                    <v-card-text>
                                        Let op: er kunnen hierna geen wijzigingen meer worden aangebracht.
                                    </v-card-text>

                                    <v-divider></v-divider>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                                color="primary"
                                                text
                                                @click="back()"
                                        >
                                            Archiveren
                                        </v-btn>
                                        <v-btn
                                                color="secondary"
                                                text
                                                @click="dialog=false"
                                        >
                                            Terug
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </div>



                    </v-expansion-panel-content>


                </v-expansion-panel>
            </v-expansion-panels>

        </v-col>

        <v-dialog
                v-model="suggestionDialog"
                width="300"
                class="mr-4"
        >


            <v-card>
                <v-card-title
                        class="headline grey lighten-2"
                        primary-title
                >
                    Suggestie toevoegen
                </v-card-title>

                <container v-for="(sug, i) in suggestions" :key="i">
                    <v-btn rounded color="grey" dark class="ma-2" @click="suggestionAdded(sug)">{{sug}} <v-icon>mdi-plus</v-icon></v-btn>
                </container>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            text
                            @click="suggestionDialog = false"
                    >
                        Sluiten
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-col>

</template>

<script>
    import axios from "axios";
    import config from '../config/config.js'
    import TimeComponent from "@/components/TimeComponent";
    export default {
        name: "Info.vue",
        data: () => ({
            alarm: {},
            images: {
                alert: require('../assets/alarm_new.png'),
                notification: require('../assets/notification_new.png'),
                info: require('../assets/event_new.png')
            },
            text: "Opgeslagen",
            snackbar: false,
            timeout: 1000,
            panel: 0,
            dialog: false,
            suggestionDialog: false,
            suggestions: []
        }),
        methods: {
            back() {
                this.dialog = false;
                this.$router.go(-1);
            },
            goToHistory(id) {
                this.$router.push({path: 'alarmHistory', query: {uid: id}});
            },
            getManual() {
                //axios.get('https://file-examples.com/wp-content/uploads/2017/10/file-sample_150kB.pdf')
                this.description = this.$route.query.uid;
                //console.log("Test log: ", this.props);
            },
            openPopup(name) {
                let max = this.alarm.workflow.length;
                let finished = 0;
                for(let i = 0; i < max; i++) {
                    if(this.alarm.workflow[i].completed) {
                        finished++
                    }
                }
                if(finished === max-1) {
                    axios
                        .post(config.url + '/alarms/archive', this.alarm)
                    this.text = "Gearchiveerd"
                    this.dialog=true;

                } else {
                    this.snackbar = true;
                    let index = this.findWithAttr(this.alarm.workflow, "name", name)
                    this.alarm.workflow[index].completed=true;
                    this.alarm.workflow[index].timestamp = new Date()
                    this.panel++
                    this.alarm.completed = true;
                    axios
                        .post(config.url + '/alarms/save', this.alarm)
                }

            },
            getPreview() {
                try {
                    let voorOnderzoek = this.alarm.workflow.find(x => x.name === "Vooronderzoek").notes || "geen"
                    let locatie = this.alarm.workflow.find(x => x.name === "Naar locatie").info || "geen"
                    let reparatie = this.alarm.workflow.find(x => x.name === "Reparatie").notes || "geen"
                    let onderdelen = this.alarm.workflow.find(x => x.name === "Reparatie").parts || "geen"
                    let conclusie = this.alarm.workflow.find(x => x.name === "Rapportage").notes || "geen"
                    let datum = this.convertTimestamp(this.alarm.timestamp)
                    return `Tijdstip: ${datum}\nLocatie alarm: ${locatie}\nNotities vooronderzoek: ${voorOnderzoek}\nNotities reparatie: ${reparatie}\nOnderdelen te bestellen: ${onderdelen}\nConclusie: ${conclusie}`

                } catch (e){
                    return ''
                }


            },
            visitTimelineItem() {
                this.$router.push({name: 'timelineItem', query: {filter: this.alarm.log_filter_id}});
            },
            convertTimestamp(ts) {
                let date = new Date(ts)
                let today = new Date()
                if(date.getDate() < today.getDate()) {
                    if (date.getMinutes() < 10 && date.getHours() < 10) {
                        return "0" + date.getHours() + ":0" + date.getMinutes()+ " (" + date.getDate() + "/" + date.getMonth() + ")"
                    } else if(date.getMinutes() < 10) {
                        return date.getHours() + ":0" + date.getMinutes()+ " (" + date.getDate() + "/" + date.getMonth() + ")"
                    } else if(date.getHours() < 10) {
                        return "0" + date.getHours()+":" + date.getMinutes()+ " (" + date.getDate() + "/" + date.getMonth() + ")"
                    }
                    return date.getHours() + ":" + date.getMinutes() + " (" + date.getDate() + "/" + date.getMonth() + ")"
                }
                if (date.getMinutes() < 10 && date.getHours() < 10) {
                    return "0" + date.getHours() + ":0" + date.getMinutes()
                } else if(date.getMinutes() < 10) {
                    return date.getHours() + ":0" + date.getMinutes()
                } else if(date.getHours() < 10) {
                    return "0" + date.getHours()+":" + date.getMinutes()
                }
                return date.getHours() + ":" + date.getMinutes()
            },
            getTimeDifference(ts) {
                let timestamp = new Date(ts)
                let now = new Date()

                let diff = now.getTime() - timestamp.getTime(); // this is a time in milliseconds
                let diff_as_date = new Date(diff);
                diff_as_date.getHours(); // hours
                diff_as_date.getMinutes(); // minutes
                diff_as_date.getSeconds(); // seconds
                const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds


                const diffDays = Math.round(Math.abs((timestamp - now) / oneDay));
                if(diffDays === 1) {
                    return "Gisteren"
                } else if(diffDays === 2) {
                    return "2 dagen geleden"
                } else if (diffDays > 2){
                    return "Meer dan 2 dagen geleden"
                } else {
                    let hours = diff_as_date.getHours()
                    let minutes = diff_as_date.getMinutes()
                    if(hours !== 0) {
                        hours--
                    }
                    return  hours + " uur en " + minutes + " minuten geleden"
                }
            },

            findWithAttr(array, attr, value) {
                for(let i = 0; i < array.length; i += 1) {
                    if(array[i][attr] === value) {
                        return i;
                    }
                }
                return -1;
            },
            addSuggestion() {
                this.suggestionDialog = true;
            },
            suggestionAdded(sug) {
                let panel = this.panel
                if(!this.alarm.workflow[panel].notes) {
                    this.alarm.workflow[panel].notes = ""
                }
                this.alarm.workflow[panel].notes = this.alarm.workflow[panel].notes + sug + '\n'
                this.suggestionDialog = false

            },
        },

        mounted () {
            axios
                .get(config.url + '/alarms/' + this.$route.query.uid)
                .then((response) => {
                    this.alarm = response.data.alarm
                    let max = this.alarm.workflow.length;
                    let finished = 0;
                    for(let i = 0; i < max; i++) {
                        if(this.alarm.workflow[i].completed) {
                            finished++
                        }
                    }
                    this.panel = finished;
                })
            axios.get(config.url + '/suggestions/conclusion').then((res) => {
                this.suggestions = res.data[0].suggestions
            })

        },
        components: {
            TimeComponent
        }
    }
</script>


<style scoped>
    .rounded-card{
        border-radius:50px;
        margin: 5px;
        background: #ffffff;
        border-color: grey;
    }

    v-card-text, v-card-title, v-card-description {
        padding: 16px;
    }

    .description {
        padding: 0px;
    }

    .some .v-expansion-panel::after * {
        border-top: none !important;
        border-top-width: 0 !important;
    }

    .v-expansion-panels {
        box-shadow: none !important;
    }

    .v-expansion-panel {
        border: 1px solid !important;
    }

    .v-expansion-panel:before { box-shadow: none !important; }
    .v-expansion-panel:after { border-top: none !important; }

    .v-timeline-item {
        padding-bottom: 5px !important;
    }

    .v-timeline {
        padding-top: 5px !important;
    }
    .some-icon {
        height: 40px !important;
        width: 40px !important;
        float: right;
        margin-top: 17px;
        margin-right: 2px;
    }


</style>
